import * as React from 'react';
import { createCartContext } from './utils';
import { CartContext as CartContextType, CartPrices, CartService, CartServiceProps } from './types';
import { useTheme } from '../theme';
import Toolbar from './Toolbar/Toolbar';
import CartFactory from './Fields/CartFactory';
import { useConfig } from '../context';

interface OwnProps {
	prices: CartPrices;
	cartServices?: CartService[];
	hideToolbar?: boolean;
	onClose?: () => void;
	renderServices?: () => React.ReactNode;
}

export const CartContext = React.createContext<CartContextType>({
	travellersById: null,
	segmentsById: null,
	totalPrices: {}
});

export type Props = OwnProps & CartServiceProps;

const CART_SERVICES = [
	CartService.Flights,
	CartService.Seats,
	CartService.Baggage,
	CartService.Meal,
	CartService.Passengers,
	CartService.Extra,
	CartService.Misc
];

const Cart: React.FC<Props> = ({
	prices,
	cartServices = CART_SERVICES,
	hideToolbar,
	onClose,
	renderServices,
	...props
}) => {
	const { servicesAvailable } = useConfig().global;

	const theme = useTheme('Cart').Cart;

	const includeInsuranceService = cartServices.includes(CartService.Insurances);

	return (
		<CartContext.Provider value={createCartContext(props.travellers, props.flight.segments, prices)}>
			<div className={theme.wrapper}>
				<div className={theme.cart}>
					{cartServices.map(type => (
						<CartFactory
							{...props}
							key={type}
							type={type}
							separateInsurance={includeInsuranceService}
							separateAnimals={servicesAvailable.animal}
						/>
					))}
					{renderServices?.()}
				</div>

				{!hideToolbar && (
					<div className={theme.toolbar}>
						<Toolbar onClick={onClose} />
					</div>
				)}
			</div>
		</CartContext.Provider>
	);
};

export default Cart;
